import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  data: [],
  loading: false,
  error: null,
};
const corporatetripSlice = createSlice({
  name: "CorTrip",
  initialState,
  reducers: {
    fetchCorporateTripRequest(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchCorporateTripSuccess(state, action) {
      state.data = action.payload.data;
      state.totalFare = action.payload.totalFare;
      state.tablelength = action.payload.tablelength;
      state.loading = false;
    },
    fetchCorporateTripFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const {
  fetchCorporateTripRequest,
  fetchCorporateTripSuccess,
  fetchCorporateTripFailure,
} = corporatetripSlice.actions;
export default corporatetripSlice.reducer;
